(() => {
  if (window.sfgStoryReady) return;
  window.sfgStoryReady = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const behavior = () => reduced.matches ? 'instant' : 'smooth';
  function purchaseTarget() {
    const main = document.querySelector('[data-sfg-main], .m-main-product');
    const target = main?.querySelector('kaching-bundles-block') || main?.querySelector('.main-product__block-buy_buttons') || main?.querySelector('form[action*="cart/add"]');
    if (target) target.id ||= 'sfg-buy-options';
    return target;
  }
  function returnToPurchase(moveFocus) {
    const target = purchaseTarget();
    if (!target) return;
    if (moveFocus) {
      const focus = [...target.querySelectorAll('[role="button"], button, input:not([type="hidden"]), select')].find(element => !element.disabled && element.getBoundingClientRect().height > 0) || target;
      if (focus === target) target.tabIndex = -1;
      focus.focus({preventScroll:true});
    }
    const header = document.querySelector('.m-header__wrapper');
    const clearance = Math.min(header?.getBoundingClientRect().height || 80,150) + 16;
    window.scrollTo({top:target.getBoundingClientRect().top + scrollY - clearance,behavior:behavior()});
  }
  function init() {
    purchaseTarget();
    document.querySelectorAll('[data-sfg-buy]:not([data-story-bound])').forEach(link => {
      link.dataset.storyBound = 'true';
      link.addEventListener('click',event => {
        event.preventDefault();
        link.closest('dialog')?.close();
        requestAnimationFrame(() => returnToPurchase(event.detail === 0));
      });
    });
    document.querySelectorAll('[data-sfg-pain]:not([data-story-bound])').forEach(root => {
      root.dataset.storyBound = 'true';
      const track = root.querySelector('.sfg-pain-track'), cards = [...track.children];
      const controls = root.querySelector('.sfg-pain-controls');
      root.style.setProperty('--sfg-card-count',Math.max(1,cards.length));
      if(!cards.length){controls.hidden=true;return;}
      const prev = root.querySelector('[data-pain-prev]'), next = root.querySelector('[data-pain-next]');
      const toggle = root.querySelector('[data-pain-toggle]'), count = root.querySelector('[data-pain-count]');
      const mobile = matchMedia('(max-width: 767px)');
      const events = new AbortController();
      const listen = (target, name, callback, options = {}) => target.addEventListener(name, callback, {...options, signal:events.signal});
      let index = 0, queued = false, visible = false, paused = false, dragging = false, timer, settled;
      const schedule = () => {
        clearTimeout(timer);
        const running = cards.length > 1 && mobile.matches && visible && !paused && !dragging && !reduced.matches && !document.hidden;
        toggle.hidden = reduced.matches;
        toggle.dataset.paused = String(paused);
        toggle.setAttribute('aria-label', paused ? toggle.dataset.play : toggle.dataset.pause);
        count.setAttribute('aria-live', running ? 'off' : 'polite');
        if (running) timer = setTimeout(() => select((index + 1) % cards.length), 5000);
      };
      const update = () => {
        const positions = cards.map(card => card.offsetLeft - cards[0].offsetLeft);
        index = positions.reduce((best,x,i) => Math.abs(x-track.scrollLeft)<Math.abs(positions[best]-track.scrollLeft)?i:best,0);
        // The last card has a trailing edge, so its final scroll offset is clamped by the browser.
        if (track.scrollLeft > 0 && track.scrollWidth-track.clientWidth-track.scrollLeft < 3) index = cards.length-1;
        root.style.setProperty('--pain-index',index);
        count.textContent = `${String(index+1).padStart(2,"0")} / ${String(cards.length).padStart(2,"0")}`;
        prev.disabled = index === 0; next.disabled = index === cards.length-1;
        controls.hidden = track.scrollWidth <= track.clientWidth + 1;
      };
      const select = nextIndex => {
        track.scrollTo({left:cards[Math.max(0,Math.min(cards.length-1,nextIndex))].offsetLeft-cards[0].offsetLeft,behavior:behavior()});
        schedule();
      };
      listen(prev,'click',()=>select(index-1));
      listen(next,'click',()=>select(index+1));
      listen(toggle,'click',()=>{paused=!paused;schedule();});
      listen(track,'scroll',()=>{
        clearTimeout(timer);clearTimeout(settled);
        if(!queued){queued=true;requestAnimationFrame(()=>{queued=false;update();});}
        // Give readers a full interval after either a swipe or an animated transition.
        settled=setTimeout(schedule,180);
      },{passive:true});
      listen(track,'pointerdown',()=>{dragging=true;clearTimeout(timer);},{passive:true});
      const release = ()=>{if(dragging){dragging=false;schedule();}};
      listen(window,'pointerup',release,{passive:true});
      listen(window,'pointercancel',release,{passive:true});
      listen(root,'focusin',event=>{if(event.target!==toggle&&event.target.matches(':focus-visible')){paused=true;schedule();}});
      listen(track,'keydown',event=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        paused=true;
        event.preventDefault();select(event.key==='Home'?0:event.key==='End'?cards.length-1:index+(event.key==='ArrowRight'?1:-1));
      });
      listen(document,'visibilitychange',schedule);
      listen(reduced,'change',schedule);
      listen(mobile,'change',()=>{update();schedule();});
      const observer = new ResizeObserver(()=>{update();schedule();});observer.observe(track);
      const visibility = new IntersectionObserver(entries=>{visible=entries[0].isIntersecting&&entries[0].intersectionRatio>=.45;schedule();},{threshold:[0,.45]});
      visibility.observe(track);
      listen(root.closest('.shopify-section')||root,'shopify:section:unload',()=>{
        clearTimeout(timer);clearTimeout(settled);observer.disconnect();visibility.disconnect();events.abort();
      },{once:true});
      update();schedule();
    });
    document.querySelectorAll('[data-sfg-questions]:not([data-story-bound])').forEach(root=>{
      root.dataset.storyBound='true';
      root.querySelectorAll('details').forEach(item=>item.addEventListener('toggle',()=>{
        if(item.open)root.querySelectorAll('details[open]').forEach(other=>{if(other!==item)other.open=false;});
      }));
    });
  }
  document.addEventListener('shopify:section:load',init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
